import config from "@/../config";
import dummyPolicy from "@/mocks/dummy_policy.js";
import axios from "axios";
import { formatDate } from "@/libs/utils"

const state = {}

const defaultErrorHandler = (error => Promise.reject(error.response))

const mutations = {}

const actions = {
  async GET_POLICIES ({}) {
    const baseUrl = `${config.apiUrl}${config.versoes[0]}`;
    const uri = `/apolices/`;
    let { data } = await axios.get(`${baseUrl}${uri}`);
    return data
  },

  async GET_POLICY({ commit }, { apoliceId }) {
    const baseUrl = `${config.apiUrl}${config.versoes[0]}`;
    const uri = `/apolices/${apoliceId}/`;
    let response = await axios.get(`${baseUrl}${uri}`);

    const { data: { endossos, ...data } } = response;

    let modalidades = {
      grupo: data.grupo_sublimite,
      adicionais: []
    };

    modalidades = (data.coberturas || []).reduce((acc, item) => {
      if (item.tipo == "basica") {
        acc.principal = item.nome;
      }
      if (item.tipo == "corretiva") {
        acc.complementar = item.nome;
      }

      item.fim_vigencia_formatted = formatDate(item.fim_vigencia);
      item.inicio_vigencia_formatted = formatDate(item.inicio_vigencia);

      return acc;
    }, modalidades);

    return {
      ...data,
      tomador: {
        cnpj_cpf: data.tomador.cnpj_cpf,
        nome: data.tomador.nome,
        endereco: data.tomador.endereco
      },
      segurado: {
        cnpj_cpf: data.segurado.cnpj_cpf,
        nome: data.segurado.nome,
        endereco: data.segurado.endereco
      },
      endossos,
      modalidades,
    };
  }

};

export default { state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/policies.js